import React from 'react';
import { useTranslation } from 'react-i18next';

interface FeedbackRatingProps {
  rating: number | null;
  compact?: boolean;
}

const FeedbackRating: React.FC<FeedbackRatingProps> = ({ rating, compact = false }) => {
  const { t } = useTranslation();
  if (rating === null || rating < 1 || rating > 5) {
    return <span className="text-body-sm text-secondary">{t('admin.feedbacks.rating.none')}</span>;
  }

  return (
    <div className="inline-flex items-center gap-2" aria-label={t('admin.feedbacks.rating.label', { rating })}>
      <span className="inline-flex text-rating" aria-hidden="true">
        {Array.from({ length: 5 }, (_, index) => (
          <span
            key={index}
            className={`material-symbols-outlined ${compact ? 'text-[17px]' : 'text-[21px]'} ${index < rating ? '' : 'text-outline-variant'}`}
            style={index < rating ? { fontVariationSettings: "'FILL' 1" } : {}}
          >
            star
          </span>
        ))}
      </span>
      <span className="whitespace-nowrap font-label-sm text-on-surface">{rating}/5</span>
    </div>
  );
};

export default FeedbackRating;
